import { FeeLine } from "@/offering/api";
import { toFeeLine } from "@/offering/hooks/use_quote_query";
import useSWR from "swr";

interface MembershipUpcomingPayment {
  id: string;
  currency: string;
  transactionType: "charge";
  paymentDate: string;
  taxAmount: number;
  taxDescription: string | null;
  promotionAmount: number;
  promotionDescription: string | null;
  promotionCode: string | null;
  totalPrice: number;
  subTotalBeforeDiscount: number;
  adjustmentAmount: number;
  unitPrice: number;
  paymentCycles: number;
  feeLines?: FeeLine[];
}

interface UseUpcomingPaymentQueryReturn {
  data: MembershipUpcomingPayment | undefined;
}

export function useUpcomingPaymentQuery(
  partnerId: string,
  subscriptionId: string
): UseUpcomingPaymentQueryReturn {
  const { data } = useSWR(
    `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/upcoming_charge`
  );

  return { data: toUpcomingPayment(data?.data) };
}

function toUpcomingPayment(data?: any): MembershipUpcomingPayment | undefined {
  try {
    if (data) {
      return {
        id: data.id,
        currency: data.currency,
        transactionType: data.transaction_type,
        paymentDate: data.payment_date,
        taxAmount: data.tax_amount,
        taxDescription: data.tax_description,
        promotionAmount: data.promotion_amount,
        promotionCode: data.promotion_code,
        promotionDescription: data.promotion_description,
        totalPrice: data.total_price,
        subTotalBeforeDiscount: data.sub_total_before_discount,
        adjustmentAmount: data.adjustment_amount,
        unitPrice: data.unit_price,
        paymentCycles: data.payment_cycles,
        feeLines: data.fee_lines?.map(toFeeLine),
      };
    }
  } catch {
    throw new Error("Error mapping data");
  }
}
